import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, EMPTY, of } from 'rxjs';
import { retry, catchError, shareReplay } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { response } from '../model/Response';

import { MenuItem, MenuData } from '../model/menu.model';
import {
  SystemControl,
  EntryControl,
  AppSetting,
} from '../model/setting/SystemControl';
import { DocumentDesign } from '../model/setting/DocumentDesign';

import { Store, select } from '@ngrx/store';
import { AppState } from '../store/buid.reducer';
import { HttpBackend } from '@angular/common/http';
import { EventLogModel } from '../model/EventLogModel';
@Injectable({
  providedIn: 'root',
})
export class SetupService {
  [x: string]: any;
  myAppApi: string;
  myAppUrlSystemcontrolList: string;
  myAppUrlAddSystemControl: string;
  myAppUrlAddDocumentNumbering: string;
  myAppUrlUpdateDocumentNumbering: string;
  myAppUrlDocumentNumberingList: string;

  myAppUrlCompanyList: string;
  myAppUrlAddCompany: string;
  myAppUrlUpdateCompany: string;
  myAppUrlDeletecompany: string;

  myAppsystemSettingEmailConfiguration: string;

  ////add design
  myAppUrlDesignList: string;
  myAppUrlAddDesign: string;
  myAppUrlUpdateDesign: string;
  myAppUrlDeleteDesign: string;
  myAppUrlAddOrganization: string;

  menuAPI: string;
  BUID: string;

  private httpClient: HttpClient;
  constructor(
    private _http: HttpClient,
    private handler: HttpBackend,
    private store: Store<AppState>,
  ) {
    this.myAppApi = environment.appUrl;
    this.myAppUrlSystemcontrolList = 'api/Master/BusinessSettingList?Id=0';
    this.myAppUrlAddSystemControl = 'api/Master/AddBusinessSetting';

    this.myAppUrlAddDocumentNumbering = 'api/Master/AddAutoGenerateNo';
    this.myAppUrlUpdateDocumentNumbering = 'api/Master/AddAutoGenerateNo';
    this.myAppUrlDocumentNumberingList =
      'api/Master/AutoGenerateNoList?AutoGenerateId=0';
    ///company

    this.myAppUrlCompanyList =
      'api/SystemMaster/CompanyList?Id=0&UserId=0&LicId=0&db=0';
    this.myAppUrlAddCompany = 'api/SystemMaster/AddCompany';

    // email configuration api
    this.myAppsystemSettingEmailConfiguration =
      'api/Master/AddBusinessEmailSetting';

    //////design
    this.myAppUrlDesignList = 'api/Report/ReportDesignList?ReportDesignId=0';
    this.myAppUrlAddDesign = 'api/Report/AddReportDesign';
    this.myAppUrlUpdateDesign = 'api/Report/UpdateReportDesign';

    this.menuAPI = 'api/SystemMaster/GetMenu?Event=1&UserId=0&UserRoleId=0';
    this.myAppUrlAddOrganization = 'api/SystemMaster/AddOrganization';

    this.httpClient = new HttpClient(handler);
    //
    this.store
      .pipe(select((state) => state.buidState.BUID))
      .subscribe((buid) => {
        this.BUID = buid;
      });
  }

  ///

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Accept: '*/*',
    }),
  };

  NewDate: any;
  getSytemList(): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + this.myAppUrlSystemcontrolList, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  getSytemListNew(): Observable<SystemControl[]> {
    return this._http
      .get<
        SystemControl[]
      >(this.myAppApi + this.myAppUrlSystemcontrolList, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }
  //for general ledger api //rajnikant  api for general ledger
  getLedgerListEnum(): Observable<SystemControl> {
    return this._http
      .get<SystemControl>(
        this.myAppApi +
          'api/Master/EnumList?Id=0&Station=LedgerInfo&Value1=CU,BO&Value2&Value3&Value4&Status=true&OffSet=1&PageSize=20',
        this.httpOptions,
      )
      .pipe(
        map((SystemControl) => {
          let data = SystemControl;
          return data;
        }),
      );
  }
  // for currency api//rajnikant  api for currency
  getCurrencyListEnum(): Observable<SystemControl> {
    return this._http
      .get<SystemControl>(
        this.myAppApi +
          'api/Master/EnumList?Id=0&Station=Currency&Value1&Value2&Value3&Value4&Status=true&OffSet=1&PageSize=20',
        this.httpOptions,
      )
      .pipe(
        map((SystemControl) => {
          let data = SystemControl;

          return data;
        }),
      );
  }

  // for currency api//rajnikant  api for addSystemControl
  addSystemControl(systemControlViewModel): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppUrlAddSystemControl,
        JSON.stringify(systemControlViewModel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  updateEntryControlVisibility(data): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + 'api/Master/AddBusinessSettingLabel',
        JSON.stringify(data),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  // for currency api//rajnikant  api for editSystemControl
  editSystemControl(): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + 'api/Master/SystemControlList?Id=0', this.httpOptions)
      .pipe(
        map((response) => {
          let data: any = response;
          return data.data;
        }),
      );
  }

  // for currency api//rajnikant  api for SystemControl
  SystemControl(sectionViewModel): Observable<SystemControl> {
    return this._http
      .post<SystemControl>(
        this.myAppApi + this.myAppUrlAddSystemControl,
        JSON.stringify(sectionViewModel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  private appSettingCache = new Map<string, Observable<AppSetting>>();

  getAppSetting(source: string): Observable<AppSetting> {
    if (!this.appSettingCache.has(source)) {
      const request$ = this._http
        .get<response>(
          this.myAppApi + 'api/Master/BusinessSettingList?Id=0',
          this.httpOptions,
        )
        .pipe(
          map((res) => res.data[0]),
          shareReplay({
            bufferSize: 1,
            refCount: false,
          }),
        );

      this.appSettingCache.set(source, request$);
    }

    return this.appSettingCache.get(source)!;
  }

  // ////entry control //UY
  //   getAppSetting(source: string): Observable<AppSetting> {
  //     return this._http.get<response>(this.myAppApi + "api/Master/BusinessSettingList?Id=0", this.httpOptions)
  //       .pipe(map(response => {
  //         this.apiResponse = response;
  //         return this.apiResponse.data[0];
  //       }));
  //   }

  apiResponse: any; // UY
  getBusinessSettingLabelList(source: string): Observable<EntryControl[]> {
    return this._http
      .get<response>(
        this.myAppApi + `api/Master/BusinessSettingLabelList?Source=${source}`,
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          this.apiResponse = response;
          return this.apiResponse.data;
        }),
      );
  }

  // getBusinessSettingLabelList(source:string): Observable<EntryControl[]> {
  //
  //   return this._http.get<EntryControl[]>(this.myAppApi + "api/Master/BusinessSettingLabelList?Source=" + source + "", this.httpOptions)
  //     .pipe(map(resp => {
  //
  //       let data = resp.data;
  //       return data;
  //     }))
  // };

  getDocumentNumberingList(
    AutoGenerateId: number,
    FormAliash,
  ): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + 'api/Master/AutoGenerateNoList?AutoGenerateId=' + AutoGenerateId + '&BranchId=' + this.BUID + '&FormAliash=' + FormAliash + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;

          return this.NewDate.data;
        }),
      );
  }

  updateDocumentNumbering(documentnumberingViewModel): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppUrlUpdateDocumentNumbering,
        JSON.stringify(documentnumberingViewModel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  // for currency api//rajnikant  api for addSystemControl
  addDocumentNumbering(documentnumberingViewModel): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppUrlAddDocumentNumbering,
        JSON.stringify(documentnumberingViewModel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  deletedocumentnumbering(AutoGenerateId: number): Observable<response> {
    return this._http
      .delete<
        response[]
      >(this.myAppApi + 'api/Master/DeleteAutoGenerateNo?AutoGenerateId=' + AutoGenerateId + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }
  /////company
  getCompanyList(userId: number = 0, licId: string): Observable<response[]> {
    ///let api = `api/SystemMaster/CompanyList?Id=0&UserId=0&cuId=0&LicId=${licId}&db=0`;
    let api = `api/SystemMaster/CompanyList?Id=0&UserId=${userId}&cuId=0&LicId=${licId}&db=0`;
    return this._http
      .get<response[]>(this.myAppApi + api, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          let data = this.NewDate.data;
          for (let i = 0; i < data.length; i++) {
            data[i].logo = this.myAppApi + 'Doc/' + data[i].logo;
          }
          return data;
        }),
      );
  }

  getCompanyDetailList(
    userId: number = 0,
    licId: string,
  ): Observable<response[]> {
    ///let api = `api/SystemMaster/CompanyList?Id=0&UserId=0&cuId=0&LicId=${licId}&db=0`;
    let api = `api/SystemMaster/CompanyDetailList?Id=0&UserId=${userId}&cuId=0&LicId=${licId}&db=0`;
    return this._http
      .get<response[]>(this.myAppApi + api, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          let data = this.NewDate.data;
          for (let i = 0; i < data.length; i++) {
            data[i].logo = this.myAppApi + 'Doc/' + data[i].logo;
          }
          return data;
        }),
      );
  }

  addCompany(companymodel): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppUrlAddCompany,
        JSON.stringify(companymodel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
  addOrganization(model): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppUrlAddOrganization,
        JSON.stringify(model),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
  addLicense(model): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + `api/SystemMaster/AddLicense`,
        JSON.stringify(model),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  getLicenseList(userId): Observable<response[]> {
    let api = `api/SystemMaster/LicenseList?LicId=0&orgId=0&UserId=${userId}`;
    return this._http
      .get<response[]>(this.myAppApi + api, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }
  getLicenseListByOrgId(orgId): Observable<response[]> {
    let api = `api/SystemMaster/LicenseList?LicId=0&orgId=${orgId}`;
    return this._http
      .get<response[]>(this.myAppApi + api, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  getLicenseListById(id): Observable<response[]> {
    let api = `api/SystemMaster/LicenseList?LicId=${id}`;
    return this._http
      .get<response[]>(this.myAppApi + api, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  getOrganizationDataById(organizationId: number): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + `api/SystemMaster/OrganizationList?OrganizationId=${organizationId}`, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }
  getOrganizationList(companyId: number, userId: number = 0): Observable<[]> {
    return this._http
      .get<
        []
      >(this.myAppApi + `api/SystemMaster/OrganizationList?OrganizationId=0&UserId=${userId}`, this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  updateOrganization(model): Observable<response> {
    return this._http
      .put<response>(
        this.myAppApi + `api/SystemMaster/UpdateOrganization`,
        JSON.stringify(model),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  deleteOrganization(Id: number): Observable<response> {
    return this._http
      .delete<response>(
        this.myAppApi +
          'api/SystemMaster/DeleteOrganization?OrganizationId=' +
          Id +
          '',
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
  deleteLicense(LicId: number): Observable<response> {
    return this._http
      .delete<response>(
        this.myAppApi + `api/SystemMaster/DeleteLicense?LicId=${LicId}`,
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  saveIRDCredentials(model): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + `api/Master/AddBusinessSyncSetting`,
        JSON.stringify(model),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
  getIRDCredentials(id): Observable<response> {
    return this._http
      .get<response>(
        this.myAppApi + `api/Master/BusinessSyncSettingList`,
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
  updateCompany(companyViewModel): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppUrlAddCompany,
        JSON.stringify(companyViewModel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  getCompanyListForEdit(companyId: number): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + 'api/SystemMaster/CompanyList?Id=' + companyId + '&UserId=0&LicId=0&db=0', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  deleteCompany(companyId: number): Observable<response> {
    return this._http
      .delete<response>(
        this.myAppApi +
          'api/SystemMaster/DeleteCompany?CompanyId=' +
          companyId +
          '',
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  ////document designer

  getDocumentDesignerList(reportDesignId: number): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + 'api/Report/ReportDesignList?ReportDesignId=' + reportDesignId + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  AddReportDesign(formData: FormData): Observable<response> {
    let httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type':
          'multipart/form-data; boundary=----WebKitFormBoundaryzuW5nPZQFQCwQtg4',
        Accept: '*/*',
        enctype: 'multipart/form-data',
      }),
    };

    return this.httpClient
      .post<response>(this.myAppApi + this.myAppUrlAddDesign, formData)
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  getDocumentDesignerEdit(reportDesignId: number): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + 'api/Report/ReportDesignList?ReportDesignId=' + reportDesignId + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  updateReportDesign(formData: FormData): Observable<response> {
    return this._http
      .put<response>(
        this.myAppApi + this.myAppUrlUpdateDesign,
        JSON.stringify(formData),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  deleteReportDesign(Id: number): Observable<response> {
    return this._http
      .delete<
        response[]
      >(this.myAppApi + 'api/Report/DeleteReportDesign?ReportDesignId=' + Id + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }

  GetCompanyVersion(Version): Observable<any> {
    return this._http
      .get<response>(
        this.myAppApi + `api/SystemMaster/CheckVersion?Version=${Version}`,
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  GetCompanyVersionAndUpdate(Version): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi +
          `api/SystemMaster/CheckAndUpdateVersion?Version=${Version}`,
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  getData(url) {
    return this._http.get(url);
  }
  getDataSynchronous(): Promise<any> {
    var url = this.myAppApi + this.menuAPI;
    return this.getData(url).toPromise();
  }

  // getMenuList() {
  //   var url=this.myAppApi + this.menuAPI;
  //   return this._http.get<MenuData>(url);
  // }

  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  addEmailConfiguration(EmailModel): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + this.myAppsystemSettingEmailConfiguration,
        JSON.stringify(EmailModel),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  getEmailCredentials(id): Observable<response> {
    return this._http
      .get<response>(
        this.myAppApi + `api/Master/BusinessEmailSettingList?id=${id}`,
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  getEventLog(): Observable<EventLogModel[]> {
    let url = this.myAppApi + `api/account/EventLogs`;
    return this._http.get<response>(url, this.httpOptions).pipe(
      map((response) => {
        return response.data;
      }),
    );
  }
  //mac binding
  addMacBinding(model): Observable<response> {
    return this._http
      .post<response>(
        this.myAppApi + `api/SystemMaster/AddMACBinding`,
        JSON.stringify(model),
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
  getMacBindingList(OrgId: number, licId: string): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + `api/SystemMaster/OTPApprovalList?OrgId=${OrgId}&LicId=${licId}` + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }
  getMacBindingEdit(macId: number, licId: string): Observable<response[]> {
    return this._http
      .get<
        response[]
      >(this.myAppApi + `api/SystemMaster/MACList?MACId=${macId}&LicId=${licId}` + '', this.httpOptions)
      .pipe(
        map((response) => {
          this.NewDate = response;
          return this.NewDate.data;
        }),
      );
  }
  deleteMacBinding(
    event: string,
    userName: string,
    userSessionId: string,
  ): Observable<response> {
    return this._http
      .delete<response>(
        this.myAppApi +
          `api/SystemMaster/OTPApproval?event=${event}&UserName=${userName}&UserSessionId=${userSessionId}` +
          '',
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  approveOtp(
    event: string,
    userName: string,
    userSessionId: string,
  ): Observable<response> {
    return this._http
      .delete<response>(
        this.myAppApi +
          `api/SystemMaster/OTPApproval?event=${event}&UserName=${userName}&UserSessionId=${userSessionId}` +
          '',
        this.httpOptions,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

    incentiveList(userId,startDate,endDate,code1): Observable<any> {
    let api = `api/SystemMaster/Incentivelist?Event=1&Id=0&OrgId=0&UserId=${userId}&LicId=0&Databasename=0&EmailId=0&Pwd=0&StartDate=${startDate}&EndDate=${endDate}&Code1=${code1}&Code2=0&Code3=0&Code4=0`;
    return this._http
      .get<response[]>(this.myAppApi + api, this.httpOptions)
      .pipe(
        map((response) => {
         
          return response;
        }),
      );
  }
}
